import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

/**
 * Password input with show/hide toggle (eye icon).
 * Props are forwarded to the underlying <Input>.
 */
export default function PasswordInput({ id, value, onChange, required, placeholder, "data-testid": testId, autoComplete = "current-password", minLength }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        id={id}
        type={show ? "text" : "password"}
        required={required}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        minLength={minLength}
        data-testid={testId}
        className="pr-10"
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        className="absolute inset-y-0 right-0 flex items-center px-3 text-slate-400 hover:text-slate-700 transition focus:outline-none"
        aria-label={show ? "Hide password" : "Show password"}
        tabIndex={-1}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
